import { Box, Typography, TableCell, IconButton, Backdrop, CircularProgress, Dialog, Button } from "@mui/material";
import { Edit, InfoOutlined, Delete } from "@mui/icons-material";
import React from "react";
import { useEffect } from "react";
import { apiRequest } from "../services/apiClient";
import { Context } from "../App";
import SortSelectTable from "../components/ui/SortSelectTable";
import Header from "../components/layout/Header";
import UserAdd from "../components/forms/UserAdd";

export default function UsersManager() {
    const { deconnect } = React.useContext(Context);
    const agent = JSON.parse(localStorage.getItem("user")) || {};
    const [users, setUsers] = React.useState([]);
    const [user, setUser] = React.useState(null);
    const [selectItems, setItems] = React.useState([]);
    const [load, setLoad] = React.useState(true);
    const [action, setAction] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const manage_dialog = (open, action='') => {
        setOpen(open);
        setAction(action);
        if(!open) setUser(null);
    }

    useEffect(() => {
        // Fetch users from the API when the component mounts
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const json = await apiRequest("/get/user", { method: "GET" });
            setUsers(json);
        } catch (error) {
            if (error.message === "SESSION_EXPIRED") {
                alert("Votre session a expiré. Veuillez vous reconnecter.");
                deconnect();
            } else {
                console.error("Failed to fetch users:", error);
            }
        } finally {
            setLoad(false);
        }
    }

    const table = [
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.nom}</TableCell>},
        {header: "Prénoms", sortable: true, sortBy:(el)=>el.prenoms.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.prenoms}</TableCell>},
        {header: "Mail", sortable: true, sortBy:(el)=>el.mail, row: (row, index)=><TableCell key={index}>{row.mail}</TableCell>},
        {header: "Status", sortable: true, sortBy:(el)=>el.active, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', textAlign:'center'}}>{row.active?'Activé':'Non activé'}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} align="right" sx={{minWidth:'110px'}} >
            <IconButton aria-label="modifier" onClick={()=>{setUser(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
            <IconButton aria-label="informations complémentaires" onClick={()=>{setUser(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" disabled={agent._id===row._id} onClick={()=>{setUser(row); manage_dialog(true, 'delete')}}><Delete fontSize="small"/></IconButton>
        </TableCell>}
    ]

    return(
        <Box>
            <Header title="Gestion des utilisateurs" />

            <Box sx={{px:{xs: 1, sm: 2, md: 3}, mb:{xs: 2, sm: 3, md: 4}}}>
                <Typography variant="h4" gutterBottom>
                    Gestion des utilisateurs
                </Typography>
                <Button variant="contained" color="primary" onClick={()=>manage_dialog(true, 'add')} sx={{mb:2}}>
                    Ajouter un utilisateur
                </Button>
                <SortSelectTable {...{data: users, table, rowsPerPageOptions: [10, 30, 50], initialRowsPerPage: 10, selectItems, setItems}} />

                <Backdrop open={load} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Dialog open={open} onClose={()=>manage_dialog(false)} maxWidth="sm" fullWidth>
                    {action==='add' && <UserAdd onClose={()=>manage_dialog(false)} onAdd={fetchUsers} />}
                    {/* {action==='edit' && <UserEdit user={user} onClose={()=>manage_dialog(false)} onUpdate={fetchUsers} />}
                    {action==='info' && <UserInfo user={user} onClose={()=>manage_dialog(false)} />}
                    {action==='delete' && <UserDelete user={user} onClose={()=>manage_dialog(false)} onDelete={fetchUsers} />} */}
                </Dialog>
            </Box>
        </Box>
    )
}